export default [
  {
    path:"/services",
    name:"Services-list",
    component: () => import("@/components/adm/services/ServicesList.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
  {
    path:"/services-create",
    name:"Services-create",
    component: () => import("@/components/adm/services/FormServices.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
  {
    path:"/services-edit/:id",
    name:"Edit-service",
    component: () => import("@/components/adm/services/FormServices.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
  {
    path:"/weight-in-create/:id",
    name:"Weight-in-create",
    component: () => import("@/components/adm/services/FormWeightIn.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
  {
    path:"/weight-in-edit/:id",
    name:"Weight-in-edit",
    component: () => import("@/components/adm/services/FormWeightIn.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
  {
    path:"/services-details/:id",
    name:"Services-details",
    component: () => import("@/components/adm/services/ServiceDetails.vue"),
    meta: {
      title: "Controle Leiteiro > Serviços"
    }
  },
]